<script lang="ts">
	import cross from "../../../core/assets/icons/cross.svg?raw";
	import Icon from "./Icon.svelte";
	import { scrollLockStore } from "../stores/scrollLockStore.js";
	import translations from "./Drawer.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";

	export let isOpen = false;
	export let position: "left" | "right";
	export let onClose: () => boolean | Promise<boolean> = () => true;
	export let dontShowCloseButton = false;
	export let id: string | undefined = undefined;
	export let label: string;

	const translate = getTranslate(translations);

	let drawerClass = "";
	export { drawerClass as class };

	let dialog: HTMLDialogElement | null = null;
	$: {
		if (dialog) {
			if (isOpen && !dialog.open) {
				dialog.showModal();
			}
			if (!isOpen && dialog.open) {
				dialog.close();
			}
		}
	}

	$: {
		if (isOpen && !$scrollLockStore) {
			scrollLockStore.set(isOpen);
		}
	}
	$: {
		if (!isOpen) {
			scrollLockStore.set(isOpen);
		}
	}

	async function close(): Promise<void> {
		const shouldClose = await onClose();

		if (shouldClose) {
			isOpen = false;
		}
	}

	function onDialogClose(): void {
		isOpen = false;
	}
</script>

<dialog
	bind:this={dialog}
	{id}
	aria-label={label}
	class="fixed inset-0 m-0 size-full max-h-none max-w-none overflow-hidden bg-transparent p-0 text-inherit backdrop:bg-transparent open:flex"
	class:flex-row-reverse={position === "right"}
	on:cancel|preventDefault={close}
	on:close={onDialogClose}
>
	<div class="bg-ltwhiteout relative overflow-y-auto {drawerClass}">
		<div class="px-[.8rem] py-12 min-[450px]:p-14">
			<slot />
		</div>
		{#if !dontShowCloseButton}
			<button type="button" on:click={close} class="absolute right-6 top-6 flex items-center gap-1 font-semibold">
				{translate("close")}
				<Icon icon={cross} class="size-4" />
			</button>
		{/if}
	</div>
	<button
		type="button"
		tabindex="-1"
		aria-hidden="true"
		class="bg-ltwhiteout/75 grid size-full flex-1 cursor-default place-items-center backdrop-blur-md"
		on:click|self={close}
	></button>
</dialog>
